// extracted by mini-css-extract-plugin
module.exports = {"container":"SideMenu_container__1oy4C","title":"SideMenu_title__3e_p_","menuItemContainer":"SideMenu_menuItemContainer__1NZ7a","menuItem":"SideMenu_menuItem__73U1S"};